module.exports = __webpack_public_path__ + "img/white.51ede81e.png";